<template>
  <div class="container container-global">
    <h2>Pilule progestative seule</h2>
    <div class="content">
      <p>Levonorgestrel , desogestrel , drospirénone</p>
      <br />
      <span>Mode d’efficacité:</span>
      <ul>
        <li>
          Glaire cervicale : la glaire devient imperméable à la migration des
          spermatozoïdes
        </li>
        <li>Endomètre : atrophie de l’endomètre</li>
        <li>
          Effet antigonadotrope pour le desogestrel et drosperinone - inhibition
          de la sécrétion des gonadotrophines et blocage de l’ovulation
        </li>
      </ul>
      <span>Comment la prescrire ? </span>
      <br />
      <br />
      <p>
        Prescription en schéma continu. <br />28 comprimés en continu <br />24+4
        : 24 cp actifs et 4 cp placebo
        <br />
        <br />
        A initier classiquement au premier jour des règles.
        <br />
        <br />
        Quant au « quickstart », il consiste en une initiation à n’importe quel
        jour du cycle (en s’assurant de l’absence de grossesse), mais ne montre
        son efficacité qu’au bout du 7ème jour (méthodes barrières dans
        l’intervalle).
        <br />
        <br />
      </p>
      <br />
      <span>Indice de pearl </span>
      <br />
      <br />
      <p>Desogestrel et drospirénone : 0.5 %</p>
      <br />
      <p>Attention : levonorgestrel : 1%- sécurité contraceptive 3 heures</p>
      <br />
      <span>Contre-indications: </span>
      <br />
      <br />
      <p>
        Accident thromboembolique veineux évolutif de moins de 6 mois
        <br />
        <br />
        Présence ou antécédent de pathologie hépatique sévère
        <br />
        <br />
        Cancer du sein ou de l’utérus
        <br />
        <br />
        Hémorragie génitale non expliquée
        <br />
      </p>
      <br />
      <span>Effets secondaires les plus fréquents : </span>
      <ul>
        <li>
          Troubles du cycle (métrorragies, dysménorrhée) – acné - prise de poids
        </li>
        <li>
          Si métrorragies de plus de 3 mois sans cause organique retrouvée🡪
          switch pour une contraception oestroprogestative en l’absence de CI
        </li>
        <li>Troubles gastro-intestinaux</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";

.container {
  margin-top: 37px;
  .content {
    margin-top: 15px;
    p {
      color: $text-color-aigm;
    }
    span {
      color: $dark-pink;
      text-decoration: underline;
    }
    ul {
      margin: 15px auto 15px auto;
      width: 90%;
      li {
        margin-top: 10px;
        color: $text-color-aigm;
      }
    }
  }
}
</style>
